'use client';

import { LinkOutlined } from '@mui/icons-material';

import { tss } from 'tss-react/mui';

import { SvgIcon } from '@mui/material';

import type { DocumentType } from '@/gql';
import { graphql } from '@/gql';

import { Or2Image } from '@/components/image/Or2Image';

import { getFileSrcAndAlt } from './file-icon/fileIcon';

const FILE_ICON_FRAGMENT = graphql(`
  fragment fileIconFields on File {
    filename
    url
    folder
  }
`);

interface Props {
  file: DocumentType<typeof FILE_ICON_FRAGMENT>;
  className?: string;
  size?: number;
  fontSize?: number;
}

const useStyles = tss.create(() => {
  return {
    fileIcon: {
      backgroundRepeat: 'no-repeat',
      display: 'inline-block',
      verticalAlign: 'middle',
    },
  };
});

export const FileIcon = ({
  className,
  file: { filename, url, folder },
  size = 32,
  fontSize = 28,
}: Props) => {
  const { src, alt, extension } = getFileSrcAndAlt(filename, Boolean(folder));
  const { classes, cx } = useStyles();

  if (url) {
    return (
      <LinkOutlined
        className={className}
        style={{ width: size, height: size, fontSize }}
      />
    );
  }

  if (extension === 'svg') {
    return (
      <SvgIcon
        className={className}
        component={src}
        viewBox={`170 190 1700 1700`}
        sx={{ height: 32, fontSize }}
      />
    );
  }

  return (
    <Or2Image
      className={cx(classes.fileIcon, className)}
      size={size}
      src={src}
      alt={alt}
      unoptimized
    />
  );
};
